import { MagpieConnection } from 'magpie-lib/connection';
import { publicApiAvailability } from '../messages/public-api/public-api-available';
import { navigationPublicApiTopicDef } from '../topics/public-api';
const TEN_SECONDS = 10000;

/**
 * Waits for the navigation public API to become available.
 *
 * This function handles two scenarios:
 * 1. If the app loads first, it listens for the navigation's public API available message
 * 2. If navigation loads first, the app requests API availability and receives a reply
 *
 * @param timeout - Maximum time to wait in milliseconds (default: 10 seconds)
 * @returns A promise that resolves when the public API is available, or rejects on timeout
 * @throws Error if the public API doesn't become available within the timeout period
 */
export const waitForPublicApiAvailable = (timeout = TEN_SECONDS) => {
  let timeoutId = null;
  const appFirst = MagpieConnection.get().forTopic(navigationPublicApiTopicDef).once(publicApiAvailability.publicApiAvailable.getType()).then(() => {});
  const navFirst = new Promise(resolve => {
    MagpieConnection.get().forTopic(navigationPublicApiTopicDef).publish(publicApiAvailability.isPublicApiAvailable.create(), {
      onReply: () => {
        resolve();
      }
    });
  });
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(() => {
      reject(new Error(`Timeout waiting for Navigation Public API to become available within ${timeout}ms`));
    }, timeout);
  });
  return Promise.race([appFirst, navFirst, timeoutPromise]).finally(() => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  });
};